import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Featured from './components/Featured';
import Categories from './components/Categories';
import Exclusive from './components/Exclusive';
import UpdateRank from './components/UpdateRank';
import Reputation from './components/Reputation';
import Faq from './components/Faq';
import AboutContact from './components/AboutContact';
import MangaModal from './components/MangaModal';
import Footer from '@/components/feature/Footer';
import type { MangaItem } from '@/mocks/manga';

export default function Home() {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState<MangaItem | null>(null);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} />
        <Featured query={query} onOpen={setSelected} />
        <Categories />
        <Exclusive onOpen={setSelected} />
        <UpdateRank />
        <Reputation />
        <Faq />
        <AboutContact />
      </main>
      <Footer />
      <MangaModal item={selected} onClose={() => setSelected(null)} />
    </div>
  );
}